import React from "react";
import {
    Box,
    Collapse,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";
import { Checkbox } from "antd";
import CustomIcon from "../../../../Components/CustomIcon";

const HealthTreeNode = ({
    node,
    level,
    openNodes,
    setOpenNodes,
    selectedIds,
    onToggle,
}) => {
    const hasChildren = node.children?.length > 0;
    const isOpen = !!openNodes[node.id];
    const isChecked = selectedIds.has(node.id);

    const handleExpand = (e) => {
        e.stopPropagation();
        setOpenNodes((prev) => ({ ...prev, [node.id]: !isOpen }));
    };

    const handleCheck = (e) => {
        onToggle(node.id, e.target.checked);
    };

    return (
        <Box sx={{ pl: `${level * 16}px`, mt: 0.25 }}>
            <Stack direction="row" alignItems="center" sx={{ minHeight: 32 }}>
                <Box sx={{ width: 20, flexShrink: 0, display: "flex", alignItems: "center" }}>
                    {hasChildren && (
                        <IconButton
                            sx={{ p: 0, width: 20, height: 20 }}
                            onClick={handleExpand}
                        >
                            <CustomIcon
                                name="primary-arrow-icon"
                                rotate={isOpen ? 90 : 0}
                            />
                        </IconButton>
                    )}
                </Box>
                <Checkbox
                    checked={isChecked}
                    onChange={handleCheck}
                    style={{ gap: 8 }}
                >
                    <Typography variant="fw400s12c494949">
                        {node.label}
                    </Typography>
                </Checkbox>
            </Stack>

            {hasChildren && (
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    {node.children.map((child) => (
                        <HealthTreeNode
                            key={child.id}
                            node={child}
                            level={level + 1}
                            openNodes={openNodes}
                            setOpenNodes={setOpenNodes}
                            selectedIds={selectedIds}
                            onToggle={onToggle}
                        />
                    ))}
                </Collapse>
            )}
        </Box>
    );
};

export default HealthTreeNode;
